/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {MdPseudoCheckbox} from './pseudo-checkbox/pseudo-checkbox';
export class MdSelectionModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  exports: [MdPseudoCheckbox],
  declarations: [MdPseudoCheckbox]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdSelectionModule_tsickle_Closure_declarations() {
/** @type {?} */
MdSelectionModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdSelectionModule.ctorParameters;
}



export {MdPseudoCheckboxState,MdPseudoCheckboxBase,_MdPseudoCheckboxBase,MdPseudoCheckbox} from './pseudo-checkbox/pseudo-checkbox';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
